var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',_vm._g(_vm._b({},'el-image',_vm.$attrs,false),_vm.$listeners),[_c('img',{staticClass:"image-slot",attrs:{"slot":"error","src":require("@/assets/img-error.png")},slot:"error"})])}
var staticRenderFns = []

export { render, staticRenderFns }